import { createClient } from "@supabase/supabase-js";

// Browser Supabase client. Reads env vars at build/dev time. Persists session
// to localStorage so refreshes keep the user logged in.

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Schema selector — defaults to "public". Overridable via VITE_SUPABASE_SCHEMA
// for sample-library work that lives in the `library` schema (or any other
// non-public schema). Sub-clients can also be created via `supabaseSchema()`.
const SUPABASE_SCHEMA = import.meta.env.VITE_SUPABASE_SCHEMA || "public";

if (!SUPABASE_URL || !SUPABASE_PUBLISHABLE_KEY) {
  // Fail fast in dev — better than running with broken auth.
  throw new Error(
    "Missing VITE_SUPABASE_URL or VITE_SUPABASE_PUBLISHABLE_KEY. " +
      "Copy .env.example → .env.local and fill in the publishable key.",
  );
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true, // handles invite + reset-password redirects
  },
  db: {
    schema: SUPABASE_SCHEMA,
  },
});

// Helper: produce a sibling client scoped to a non-public schema (e.g. the
// `library` schema for sample-library tables). Pages that need to query a
// different schema directly via PostgREST call this once per render and use
// it like a normal supabase-js client.
export function supabaseSchema(schema: string) {
  return createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
    auth: {
      storage: localStorage,
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
    db: { schema },
  });
}
